export const Script = ({ children, className = "", testid }) => (
  <span className={`script ${className}`} aria-hidden="true" data-testid={testid}>{children}</span>
);

const SRC = { main: [320, 560], magenta: [280], green: [280], amber: [280] };

export const Mascot = ({ kind = "main", className = "", eager = false, blink = false }) => {
  const [w, w2] = SRC[kind];
  return (
    <span className={`mascot m-${kind} ${className}`} aria-hidden="true">
      <img src={`/media/mascot-${kind}-${w}.webp`} srcSet={w2 ? `/media/mascot-${kind}-${w}.webp ${w}w, /media/mascot-${kind}-${w2}.webp ${w2}w` : undefined}
        sizes={w2 ? "(max-width: 960px) 30vw, 14vw" : undefined} alt="" width={w} height={kind === "main" ? 346 : kind === "green" ? 371 : kind === "amber" ? 299 : 280}
        loading={eager ? "eager" : "lazy"} decoding="async" />
      {blink && <><i className="lid l1" /><i className="lid l2" /></>}
    </span>
  );
};
